import { Navigate, Route, useSearchParams } from "react-router-dom";

import { ACCESS_RULE } from "@js/routes/constants";
import { ProtectedRoute } from "@js/routes/protected-route";

import { CreateAccountPage } from "../components/create-account/create-account-page";
import { NewSelfServeRedirect } from "../components/create-account/new-self-serve-redirect";
import { OnboardingFormWrapper } from "../components/form-wrapper";
import { PROF_NET_ONBOARDING_PATHS } from "../constants";
import { getSignupRouteRedirect } from "../utils";

const SignupRouteRedirect = () => {
  const [params] = useSearchParams();
  const to = getSignupRouteRedirect(params);

  return <Navigate to={to} replace />;
};

export const OnboardingRoutes = (
  <>
    <Route
      path=""
      element={
        <ProtectedRoute rules={[ACCESS_RULE.NOT_AUTHENTICATED_OR_IN_IFRAME]}>
          <OnboardingFormWrapper />
        </ProtectedRoute>
      }
    >
      <Route index element={<SignupRouteRedirect />} />
      <Route
        path={PROF_NET_ONBOARDING_PATHS.GOALS_PAGE.routePath}
        element={<SignupRouteRedirect />}
      />
      <Route
        path={PROF_NET_ONBOARDING_PATHS.INTERESTS_PAGE.routePath}
        element={<SignupRouteRedirect />}
      />
      <Route
        path={PROF_NET_ONBOARDING_PATHS.CREATE_ACCOUNT_PAGE.routePath}
        element={
          <NewSelfServeRedirect>
            <CreateAccountPage />
          </NewSelfServeRedirect>
        }
      />
      <Route path="*" element={<Navigate to="/page-not-found" replace />} />
    </Route>
  </>
);
